import React from "react";
import PropTypes from "prop-types";

class Tab extends React.Component {
  componentDidMount() {
    this.props.registerTabsGroup(this.props.group);
    if (this.props.default) {
      this.props.setActiveTab(this.props.group, this.props.name);
    }
  }

  handleNavigation = (e) => {
    e.preventDefault();
    const { group, name } = this.props;
    if (!this.props.isActive) {
      this.props.setActiveTab(group, name);
    }
    if (this.props.closeOnSecond && this.props.isActive) {
      this.props.setActiveTab(group, null);
    }
    this.props.onClick();
  };

  render() {
    const { name, children, className, isActive } = this.props;
    return (
      <a
        onClick={this.handleNavigation}
        href={`#${name}`}
        className={`Tabs__Tab${className ? ` ${className}` : ""}${
          isActive ? " active" : ""
        }`}
      >
        {children}
      </a>
    );
  }
}

Tab.propTypes = {
  name: PropTypes.string.isRequired,
  closeOnSecond: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  group: PropTypes.string.isRequired,
  default: PropTypes.bool,
  isActive: PropTypes.bool,
  registerTabsGroup: PropTypes.func,
  setActiveTab: PropTypes.func,
  onClick: PropTypes.func,
};

Tab.defaultProps = {
  closeOnSecond: false,
  default: false,
  isActive: false,
  className: "",
  registerTabsGroup: () => null,
  setActiveTab: () => null,
  onClick: () => null,
};

export default Tab;
